import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Pelayanannya cepat dan harga relatif murah saya ganti batre imac prosesnya cuman 1 jam",
    name: "masterjo barbershop",
    detail: "iMac · Battery replacement",
  },
  {
    quote:
      "servisnya cepat, bisa ditunggu, kakak sama abangnya juga ramah 🫶🏻",
    name: "Maudy Indah Permata Astie",
    detail: "iPhone 14 · Stuck Logo",
  },
  {
    quote:
      "Macbook air m4 layarnya bergaris, ganti di EZ Device cepet banget jadi kaya baru lagi",
    name: "Fransisca M. S. D.",
    detail: "MacBook Air M4 · Board-level repair",
  },
];

export default function Testimonials() {
  return (
    <section
      className="py-20 lg:py-28 bg-[#F8F8F8]"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="eyebrow mb-4">Reviews</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
            Feedback dari pelanggan setelah proses repair selesai!
            <br />
            <span className="text-[#FF3333]">Testimonial  : </span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex flex-col gap-5"
              data-testid={`testimonial-${i + 1}`}
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, idx) => (
                  <Star
                    key={idx}
                    className="w-4 h-4 fill-[#FFD600] text-[#FFD600]"
                  />
                ))}
              </div>
              <blockquote className="font-display text-xl lg:text-2xl font-bold leading-tight tracking-tight">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-auto pt-4 border-t border-[#E5E5E5]">
                <div className="font-semibold text-sm">{t.name}</div>
                <div className="font-mono-ez text-xs text-[#525252] uppercase tracking-widest mt-1">
                  {t.detail}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
